/* eslint-disable */
export default {
  forward: '착신 전환',
  reply: '회신',
  ignore: '무시',
  toVoicemail: '음성 사서함에 보내기',
  answer: '응답',
  answerAndEnd: '응답 후 종료',
  answerAndHold: '응답 후 대기',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
